import { Link } from 'react-router-dom';

const DropdownMenu = ({ id, iconClass, label, submenuId, isOpen, toggleDropdown, links }) => (
  <li className={`nav-item dropdown ${isOpen ? 'show' : ''}`}>
    <button
      className="nav-link btn btn-link text-white d-flex align-items-center w-100"
      onClick={toggleDropdown}
      aria-expanded={isOpen}
      aria-controls={submenuId}
    >
      <i className={`${iconClass} me-2`}></i>
      <span className="flex-grow-1 text-start">{label}</span>
      <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} ms-auto`}></i>
    </button>
    <ul className={`collapse list-unstyled ps-3 ${isOpen ? 'show' : ''}`} id={submenuId}>
      {links.map(({ to, label, iconClass }) => (
        <li key={to}>
          <Link to={to} className="nav-link text-white d-flex align-items-center">
            <i className={`${iconClass} me-2`}></i>
            {label}
          </Link>
        </li>
      ))}
    </ul>
  </li>
);

export default DropdownMenu;
